import { render } from "./icon-fontawesome.vue?vue&type=template&id=51f8d3a9"
import script from "./icon-fontawesome.vue?vue&type=script&lang=js"
export * from "./icon-fontawesome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__